import { h, Component } from 'preact';
// import Store from 'store/store';
import { joinClasses } from 'utils/utils';

import IconOnline from 'components/icons/online';

import s from 'components/onlineIndicator/onlineIndicator.scss';

export default class OnlineIndicator extends Component {
	render(props) {
		const { offline } = props;

		return (
			<div class={joinClasses(s.root, props.offline && s.offline)}>
				<span class={s.text}>{offline ? 'OFFLINE' : 'ONLINE'}</span>
				<span class={s.icon}>
					<IconOnline />
				</span>
			</div>
		);
	}
}